// src/pages/customer-panel/settings/DriveSettingsPage.js
import SettingsPage from './SettingsPage';

export default function DriveSettingsPage() {
    return <SettingsPage mode="drive" />;
}
